import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70791a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Misc - tools for developers", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Værktøjer for udviklere", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-2 form-button" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getDummy && _ctx.getDummy(...args)), ["prevent"]))
        }, [
          _createElementVNode("fieldset", null, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  id: "submit-button-forecast",
                  type: "submit",
                  class: "button button-secondary adjust-button-size",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportEMF()))
                }, "Exporter EMF stamdata "),
                _createElementVNode("button", {
                  id: "submit-button-forecast",
                  type: "submit",
                  class: "button button-secondary adjust-button-size",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportEMCToEMFMapping()))
                }, "Exporter EMC stamdata ")
              ])
            ]),
            (_ctx.recalculateErrors.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.recalculateErrors), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}